<div class="modal">
  <div class="feedback-modal" animate.enter="modal-slide-in">
    <div class="tick-illustration" animate.enter="tick-bounce">
      <img src="assets/images/smart-fix-assets/feedback-modal.svg" alt="feedback-icon" />
    </div>
    <h4>Thanks for your feedback!</h4>
  </div>
</div>
